var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 16.2665C28 15.2799 27.9183 14.5599 27.7415 13.8132H16.2449V18.2665H22.9931C22.8571 19.3732 22.1224 21.0399 20.4898 22.1598L20.4669 22.3089L24.1019 25.0686L24.3537 25.0932C26.6666 22.9999 28 19.9199 28 16.2665Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2441 28C19.5502 28 22.3257 26.9333 24.3529 25.0934L20.489 22.1599C19.455 22.8666 18.0672 23.3599 16.2441 23.3599C13.0061 23.3599 10.2578 21.2666 9.27814 18.3733L9.13454 18.3852L5.35482 21.2519L5.30539 21.3866C7.31896 25.3066 11.455 28 16.2441 28Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27885 18.3734C9.02035 17.6267 8.87075 16.8266 8.87075 16C8.87075 15.1733 9.02035 14.3733 9.26525 13.6267L9.2584 13.4677L5.4313 10.5549L5.30609 10.6133C4.47619 12.24 4 14.0667 4 16C4 17.9333 4.47619 19.7599 5.30609 21.3866L9.27885 18.3734Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2442 8.63996C18.5435 8.63996 20.0945 9.61329 20.9789 10.4267L24.4346 7.12C22.3123 5.18667 19.5503 4 16.2442 4C11.455 4 7.31897 6.69331 5.30539 10.6133L9.26456 13.6266C10.2578 10.7333 13.0061 8.63996 16.2442 8.63996Z",
    fill: "#EB4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.bc7d2f65eed583c5ee51f09b4b7072e4.svg";
export { ForwardRef as ReactComponent };